(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    (function(){
        // for each section found, play the first video
        var sections = document.querySelectorAll('.section--step-by-step');
        if (!sections.length) return;
        for (let instance of sections) {
          let video_inst = instance.querySelectorAll('video');
          if (!video_inst) return;
          video_inst.forEach(function(elem){
            elem.setAttribute('data-matomo-ignore', '');
          });
        }
        // listen to video "ended" event, find next in container, play next video
        document.addEventListener('ended', function(e){
            var currentVideo = e.target;
            var container = currentVideo.closest('.section__steps');
            var nextVideo = currentVideo.parentElement.nextElementSibling;
            nextVideo = ( nextVideo ? nextVideo : container.firstElementChild ).querySelector('video');
            // delay 500ms then play
            if (nextVideo) setTimeout(function(){
                nextVideo.load();
                nextVideo.play();
            }, 500);
        }, true);
    })();

}));
